module.exports = __webpack_public_path__ + "static/media/cert_106.6a50485c.jpg";